import React, { useEffect, useState } from "react";
import { classnames, Icon } from "@culturehq/components";

import { Trans } from "app/utils";

import MiniDisplayIcon from "../icons/MiniDisplayIcon";
import LayoutBLIcon from "../icons/LayoutBLIcon";
import LayoutBrIcon from "../icons/LayoutBrIcon";
import LayoutCenterIcon from "../icons/LayoutCenterIcon";
import { CurrentOption } from "./EffectsSDKCameraRecorder";

interface LayoutOptionsProps {
  currentOption: CurrentOption;
  effectsSDK: any;
  isDisableOption: (option: CurrentOption) => boolean;
  onSelectOption: (option: CurrentOption) => void;
  open: boolean;
}

const LayoutOptions: React.FC<LayoutOptionsProps> = ({
  currentOption,
  effectsSDK,
  isDisableOption,
  onSelectOption,
  open
}) => {
  const [layoutSelection, setLayoutSelection] = useState<"center" | "left-bottom" | "right-bottom">("center");

  useEffect(() => {
    if (!open) {
      setLayoutSelection("center");
    }
  }, [open]);

  const handleLayoutChange = (layout: "center" | "left-bottom" | "right-bottom") => {
    if (effectsSDK) {
      effectsSDK.setLayout(layout);
      setLayoutSelection(layout);
    }
  };

  return (
    <div
      data-testid="layout-options"
      className={classnames("Options-Container__effects", isDisableOption("layout") ? "disabled" : "")}
    >
      {currentOption === "layout" && (
        <div
          data-testid="layout-options-menu"
          className="option-menu option-menu__layout chq-ffd--sl--opts chq-ffd--sl--opts-open"
        >
          <div className="items-container">
            <div onClick={() => { handleLayoutChange("center"); }} data-testid="layout-center">
              <LayoutCenterIcon className={classnames("item", layoutSelection === "center" ? "item__active" : "")} />
            </div>
            <div onClick={() => { handleLayoutChange("left-bottom"); }} data-testid="layout-left-bottom">
              <LayoutBLIcon className={classnames("item", layoutSelection === "left-bottom" ? "item__active" : "")} />
            </div>
            <div onClick={() => { handleLayoutChange("right-bottom"); }} data-testid="layout-right-bottom">
              <LayoutBrIcon className={classnames("item", layoutSelection === "right-bottom" ? "item__active" : "")} />
            </div>
          </div>
        </div>
      )}
      <div
        data-testid="layout-option-button"
        className="option"
        onClick={() => onSelectOption("layout")}
      >
        <div className="icon-container">
          {currentOption === "layout" ? (
            <Icon className="icon-container__icon" icon="close" />
          ) : <MiniDisplayIcon data-testid="mini-display-icon" className="icon-container__icon" />}
        </div>
        <span className="option-legend"><Trans>Layout</Trans></span>
      </div>
      <div
        data-testid="layout-option-arrow"
        className="arrow"
        onClick={() => onSelectOption("layout")}
      >
        <span aria-hidden="true" className={classnames("chq-dd--caret video-effects", { "chq-dd--caret-ex ": currentOption === "layout" })} />
      </div>
    </div>
  );
};

export default LayoutOptions;
